{
  "en": {
    "notification-management": {
      "code": {
        "canvas": "Canevas",
        "mail": "Mail",
        "report": "Livrable",
        "invitation": "Invitation",
        "topic": "Topic",
        "report_sent": "Report sent"
      }
    },
    "global": {
      "yes": "Yes",
      "no": "No",
      "back": "Back",
      "finish": "Submit",
      "search": "Search"
    },
    "camera": {
      "errors": {
        "notSupported": "Camera access is not supported on this browser",
        "accessError": "Error accessing camera",
        "notActive": "Camera is not active",
        "captureError": "Error capturing picture",
        "stopError": "Error stopping camera",
        "fileSelectionError": "Error selecting file",
        "fileInputError": "Error with file input",
        "galleryError": "Error accessing gallery"
      }
    },
    "dashboard": {
      "logout": "Logout",
      "profile_btn": "My Profile",
      "steering": "Steering",
      "change_password": "Change password"
    },
    "avis": {
      "canvas_viewer": "Canvas",
      "bim_viewer": "BIM",
      "empty_viewer": "Empty"
    },
    "reports": {
      "author": "Author",
      "report_id": "Report ID",
      "choose_report": "Choose a report",
      "list_of_reports": "List of reports already created",
      "name": "Name of report",
      "date": "Creation Date",
      "sheetNumber": "Sheet number",
      "chrono": "Chrono number",
      "sentDate": "Sent date",
      "meeting": "Meeting",
      "visit": "Visit",
      "status": "Status",
      "sAdvice": "Supended topic",
      "dAdvice": "Negatif topic",
      "projectName": "Project name",
      "statuses": {
        "GENERATING": "GENERATING",
        "READY": "READY",
        "SENT": "SENT",
        "ERROR": "ERROR"
      },
      "tutoring": "Tutorat",
      "choose_recipients": "Choose recipients",
      "choose_contributors": "Choose contributors",
      "mailCreationTitle": "Mail generation",
      "createDgdMailLabel": "Send a DGD mail?",
      "go_to": "Go to",
      "unnamed_report": "Unnamed report",
      "send": "Send",
      "sent": "Sent",
      "synthese": "Synthese",
      "recreate": "Recreate",
      "delete": "Delete",
      "confirm_delete": "Are you sure you want to delete this report?",
      "additional_data": {
        "document_name": "Name of document",
        "add_specifics": "Add specific information to the report",
        "date_of_visit": "Date of visit",
        "entitled": "Entitled",
        "l_mission_unfavorable_topic": "Are there negative topics on mission L about structural integrity in the cold?",
        "l_mission_s_d_count_positive": "There are negative topics on mission L about structural integrity in the cold",
        "l_mission_s_d_count_is_null": "There is no negative topics on mission L about structural integrity in the cold",
        "generate_solidity_question": "Would you like to also generate Solidity Attestation ?",
        "no_rfct_exists": "There is no RFCT report in this project",
        "reference_documents": "Select from the list of Socotec reports",
        "parasismic_document": "Initial parasismic document reference",
        "visits_and_meetings": "Visits and meetings",
        "add_visit_or_meeting": "Add visit or meeting",
        "witnesses": "Attendees for the visit",
        "nsi_accessibility": {
          "ladder_way": "Ladder way",
          "vehicle_ways": "Vehicle ways"
        },
        "final_attestation_answer": {
          "maintainedUnfavorableTopics": "Emmited and maintained unfavorable topics on the cold stability of the construction under normal conditions of use.",
          "liftedUnfavorableTopics": "Emmited and lifted unfavorable topics on the cold stability of the construction under normal conditions of use.",
          "didntEmitUnfavorableTopics": "Did not emit unfavorable topics on the cold stability of the construction under normal conditions of use."
        },
        "addressRequired": "This report requires an address"
      },
      "tryAgainError": "An error occurred while generating the report, please try again.",
      "badConfigError": "An error occurred while generating the report, bad project configuration, contact support.",
      "reportGenerationSuccess": "The report has been successfully generated.",
      "validationError": "An error occurred during validation of the report, please try again.",
      "generationError": "An error occurred during generation of the report, please try again.",
      "uploadError": "An error occurred during the upload of the report, please try again.",
      "steppers": {
        "confirmationDialog": {
          "title": "Quit without generating",
          "message": "Any data entered will not be saved. Are you sure you want to leave?",
          "quite": "Quit"
        }
      }
    },
    "canvas_viewer": {
      "code": "Rubrique code",
      "label": "Name"
    },
    "project": {
      "avis": "Avis",
      "document": "Documents",
      "reports": "Reports",
      "details": "Project details",
      "ged": "GED",
      "webmail": "Go to webmail",
      "download": "Download",
      "name": "Name",
      "tags": "Tags",
      "type": "Type",
      "phase": "Phase",
      "batch": "Batch",
      "creator": "Creator",
      "updated_at": "Updated at",
      "state": "State",
      "view": "View",
      "size": "Size",
      "file": "File",
      "open": "Open",
      "type_to_search": "Type to search",
      "move_to": "Move to",
      "unselect_all": "Unselect all",
      "create_folder": "Create a folder",
      "delete": "Delete",
      "cancel": "Cancel",
      "validate": "Validate",
      "folder_name": "Folder's name",
      "file_name": "File's name",
      "project_document": "Project's documents",
      "error_conversion": "Error in conversion",
      "rename": "Rename",
      "rename_folder": "Rename folder",
      "rename_file": "Rename file",
      "advice": "Advice",
      "missing": "missing",
      "save": "Save",
      "save_text": "Save",
      "upload": "Upload",
      "upload_text": "Upload your first file",
      "configure": "Configure project",
      "role": "role",
      "configuration": "Configuration",
      "dashboard": "Dashboard",
      "case_number": "Project code",
      "address": "Address",
      "email_address": "Email address",
      "missions": "Missions",
      "otherMissions": "Other missions",
      "planification": "Planification",
      "topic_history": "Track topics with status S and D",
      "risks": "Risks",
      "risk_analysis": "Risk analysis",
      "plan_of_action": "Action plan in progress",
      "wait_for_bimdata_api": "Pending authentication Bimdata API",
      "error_for_bimdata_api": "Api Bimdate in error, please reload the page",
      "observations": "Observations",
      "relation": {
        "company": "Company",
        "legal_form": "Legal form",
        "client_references": "Client references",
        "client": "Client",
        "decision_center": "Decision center",
        "address": "Address",
        "client_contact": "Client contact",
        "production_unit": "Production unit",
        "contracting_agency": "Contracting agency",
        "project_manager": "Project manager"
      },
      "affaire": {
        "details": "Details",
        "case_number": "Case number",
        "case_label": "Operaiton name",
        "project_name": "Project name",
        "email": "Email",
        "characteristics": "Characteristics",
        "work_description": "Description",
        "generate_work_description": "Generate work description",
        "recover_pc_at_information": "Recover PC/AT information",
        "initial_amount": "Initial amount (*)",
        "final_amount": "Final amount",
        "revised_works_amount": "Updated works amount",
        "revised_works_amount_tooltip": "For internal use, this revised amount is not yet included in the reports.",
        "estimated_amount": "Estimated amount",
        "RICT_publication_date": "RICT publication date",
        "estimated_duration": "Estimated duration (*)",
        "ope_start_date": "Start date (*)",
        "location": "Project location",
        "address": "Address",
        "post_code": "Post code",
        "city": "City",
        "building_permit": "Building permit",
        "building_ministerial_authorization": "Ministerial Authorization Number",
        "BP_number": "BP number",
        "BP_acquisition_date": "Date of acquisition",
        "BP_request_date": "Date of filing request",
        "BP_possible_amendments_date": "Possible amendments date",
        "chrono_number": "Chronorapsotec number",
        "invoice_date_start": "Invoice work start date",
        "dce_date": "DCE Date",
        "other": "Other",
        "safety_register_review": "Review of the safety register",
        "safety_register_constitution_status": "Register Constitution",
        "safety_register_revision_date": "Last revision of the register",
        "O_case_status": "Case status",
        "O_deadline_type": "Deadline type",
        "date_work_deadline": "Work deadline date",
        "ceaRef": "CEA reference",
        "show_fields_characteristics": "Show fields annotated (*) in the report's pdf",
        "competent_authority_name": "Name of the Competent Authority",
        "expiration_date": "Expiration date",
        "cover_photo": "Project photo"
      },
      "mission": {
        "case_total_before_tax": "Total fees on case",
        "case_sale_amount": "Total fees on case from sales",
        "case_invoiced": "TC invoiced total on this case",
        "invoice_date_last_deadline": "Last work echeance date",
        "mission_content": "Mission Content",
        "date_review_contract": "Contract review date",
        "project_sale_amount": "TC Fees on this project(€ or k€)",
        "project_sale_invoiced": "TC Fees invoiced on this project (€ or k€)",
        "technical_control": "Technical Control (all missions)",
        "technical_control_organism": "Accredited Organization",
        "other_missions": "Other missions H / J...",
        "misson_informations": "Information about the mission",
        "technical_control_themes": "AMO canvas themes",
        "theme_content": "Theme Content",
        "other_themes": "Other themes",
        "additional_comments": "Additional comments",
        "mission_limits": "Mission limits"
      },
      "external_profile": "Profile",
      "users": "Users",
      "aiPortal": "AI Portal"
    },
    "projects": {
      "projects": "My projects",
      "case_number": "Project code",
      "client": "Client",
      "city": "City",
      "status": "Status",
      "manager": "Manager",
      "atlas_methodo": "Atlas Phase",
      "updated_at": "Last Updated",
      "is_bim": "BIM ?",
      "archive": "Archive",
      "add_project": "Add a project",
      "add_project_title": "Create a new project",
      "project_id": "Project ID",
      "project_name": "Project name",
      "project_manager": "Project manager",
      "client_name": "Name",
      "address": "Address",
      "postal_code": "Postal code",
      "email_address": "Email address",
      "add": "Add Project",
      "project_not_found": "Project not found",
      "project_open_failed": "Unable to open the project",
      "project_access_denied": "You do not have access to this project"
    },
    "canvas": {
      "canvas": "Canvas",
      "canvas_list": "Canvas list"
    },
    "cloud_list": {
      "clouds_list": "Clouds list",
      "rename_cloud": "Rename Cloud",
      "cloud_name": "cloud's name"
    },
    "project_list": {
      "new_project": "New Project",
      "submit": "Submit",
      "project_name": "Project's name",
      "remove": "Remove",
      "rename_project": "Rename Project"
    },
    "dms": {
      "no_creator": "No Creator",
      "move_here": "Move here",
      "move_to": "Move to",
      "choose_destination": "Choose destination"
    },
    "configuration": {
      "title": "Canvas configuration",
      "success_message": "Project successfully updated",
      "error_message": "Error updating project",
      "project_id": "Project ID",
      "isProjectInBIM": "Is this a BIM project?*",
      "isProjectRPP": "Does this project have any RPP?*",
      "missions": "Missions",
      "no_mission": "No available mission",
      "destinations": "Destinations",
      "no_destination": "No destination for this selection of missions",
      "types": "Types",
      "no_type": "No type for this selection of destinations",
      "submit_error": "Could not update the configuration",
      "submit_success": "Configuration updated",
      "finish": "Save",
      "RPP": "RPP",
      "successRpp": "RPP successfully updated",
      "errorRpp": "Error when update RPP",
      "isProjectCEA": "Is this a CEA project ? (french nuclear industry) *",
      "isDefenseSecret": "Is this a secret defense project ?",
      "risks": "Risks",
      "themes": "Themes",
      "no_theme": "No available theme"
    },
    "notification": {
      "ProjectUpdated": "Project correctly updated !",
      "Close": "Close",
      "ErrorSaving": "Update error !",
      "noAgency": "No agency linked to project"
    },
    "SEDI": {
      "ExportFailed": "Can't export documents !",
      "ImportFailed": "Can't import documents !",
      "TaskTimeout": "The task is still in progress. It may take longer than expected.",
      "bim360Error": "An error as occured plz check your connector status",
      "ImportCompletedWithErrors": "Import completed with some errors",
      "ImportCompletedSuccessfully": "Import completed successfully",
      "WorkspaceSyncFailed": "Workspace synchronization failed!",
      "WorkspaceSyncSuccess": "Workspace synchronized successfully",
      "WorkspaceSyncPartialError": "Workspace synchronized with some errors",
      "WorkspaceSyncTimeout": "Synchronization has started successfully. This operation may take up to 6 minutes."
    },
    "actionPlan": {
      "actionPlan": "Action",
      "addActionPlan": "Add action",
      "status": "State",
      "type": "Type",
      "description": "Description",
      "defaultDocumentDescription": "Excecution document to be transmitted",
      "defaultWorkDescription": "Visit to be done",
      "statuses": {
        "DOING": "Doing",
        "DONE": "Done"
      },
      "types": {
        "DOCUMENT": "Documents",
        "WORK": "Works"
      }
    },
    "topic": {
      "name": "Review Title",
      "author": "By",
      "modifiedByUserAt": "Last modification"
    },
    "addDocumentsSuccess": "{count} document{plurial} successfully added",
    "document": {
      "dragDrop": "Click here or drop a file",
      "import-success": "Document(s) imported successfully",
      "deleteDocument": "Delete the document",
      "deleteDocuments": "Delete the documents",
      "deleteMessage": "Are you sure you want to delete this document?",
      "deleteMessageMultiple": "Are you sure you want to delete these documents?",
      "editLinkDocError": "You cannot edit document(s) shared with other applications / projects. Concerned document(s): {docNames}"
    },
    "common": {
      "others": "Others"
    },
    "ITM": "ITM",
    "CT": "RapsoTEC",
    "AMO": "HORIZON",
    "filter": "Filter",
    "close": "Close",
    "back": "Back",
    "continue": "Continue",
    "delete": "Delete",
    "deleteAll": "Erase all",
    "favorites": "Favorites",
    "myCanevas": "My Canvas",
    "edit": "Edit",
    "preview": "Preview",
    "download": "Download",
    "documentsWithTopics": "Document(s) linked to a topic",
    "documentsWithoutTopics": "Document(s) without topic"
  },
  "fr": {
    "notification-management": {
      "code": {
        "canvas": "Canevas",
        "mail": "Mail",
        "report": "Livrable",
        "invitation": "Invitation",
        "topic": "Avis",
        "report_sent": "Rapport envoyé"
      }
    },
    "global": {
      "yes": "Oui",
      "no": "Non",
      "back": "Précédent",
      "finish": "Finaliser",
      "search": "Rechercher"
    },
    "camera": {
      "errors": {
        "notSupported": "L'accès à la caméra n'est pas pris en charge par ce navigateur",
        "accessError": "Erreur d'accès à la caméra",
        "notActive": "La caméra n'est pas active",
        "captureError": "Erreur lors de la capture de la photo",
        "stopError": "Erreur lors de l'arrêt de la caméra",
        "fileSelectionError": "Erreur lors de la sélection du fichier",
        "fileInputError": "Erreur avec l'élément de sélection de fichier",
        "galleryError": "Erreur d'accès à la galerie"
      }
    },
    "dashboard": {
      "logout": "Se déconnecter",
      "profile_btn": "Mon profil",
      "steering": "Pilotage",
      "change_password": "Changer mon mot de passe"
    },
    "avis": {
      "canvas_viewer": "Canevas",
      "bim_viewer": "BIM",
      "empty_viewer": "Vide"
    },
    "reports": {
      "author": "Auteur",
      "report_id": "Rapport ID",
      "choose_report": "Choisir un livrable",
      "list_of_reports": "Liste des rapports déjà émis",
      "name": "Nom du rapport",
      "date": "Date de création",
      "sheetNumber": "N. de fiche",
      "chrono": "Numéro chrono",
      "sentDate": "Date d'envoi",
      "meeting": "Réunion",
      "visit": "Visite",
      "status": "Statut",
      "sAdvice": "Avis suspendu",
      "dAdvice": "Avis défavorable",
      "projectName": "Nom du projet",
      "statuses": {
        "GENERATING": "En génération",
        "READY": "Prêt",
        "SENT": "Envoyé",
        "ERROR": "Erreur"
      },
      "tutoring": "Tutorat",
      "choose_recipients": "Liste de diffusion",
      "choose_contributors": "Liste des signataires",
      "mailCreationTitle": "Génération de courrier",
      "createDgdMailLabel": "Envoyer une demande de DGD ?",
      "go_to": "Etape suivante",
      "unnamed_report": "Rapport sans nom",
      "send": "Envoyer",
      "sent": "Envoyé",
      "synthese": "Synthèse",
      "recreate": "Recréer",
      "delete": "Supprimer",
      "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce rapport ?",
      "additional_data": {
        "document_name": "Nom du document",
        "add_specifics": "Données spécifiques à ce rapport",
        "date_of_visit": "Date de la visite",
        "entitled": "Intitulé",
        "l_mission_unfavorable_topic": "Avis défavorable(s) maintenu(s) dans le RFCT concernant la mission L solidité à froid ?",
        "l_mission_s_d_count_positive": "Il y a des avis défavorables maintenus dans le RFCT concernant la mission L solidité à froid",
        "l_mission_s_d_count_is_null": "Il n'y a pas d'avis défavorables maintenus dans le RFCT concernant la mission L solidité à froid",
        "generate_solidity_question": "Voulez vous inclure l'attestation solidité ?",
        "no_rfct_exists": "Il n'y a pas de rapport RFCT dans l'affaire",
        "reference_documents": "Sélection dans la liste des Rapports Socotec",
        "parasismic_document": "Référence du document initial parasismique",
        "visits_and_meetings": "Visites ou réunions",
        "add_visit_or_meeting": "Ajouter visite et réunion",
        "witnesses": "Personnes présentes pour la visite",
        "nsi_accessibility": {
          "ladder_way": "Voie échelle",
          "vehicle_ways": "Voies engins"
        },
        "final_attestation_answer": {
          "maintainedUnfavorableTopics": "A émis des avis défavorables maintenus sur la stabilité à froid de la construction dans les conditions normales d’utilisation.",
          "liftedUnfavorableTopics": "A émis et levé les avis défavorables sur la stabilité à froid de la construction dans les conditions normales d’utilisation.",
          "didntEmitUnfavorableTopics": "N’a pas émis d’avis défavorable sur la stabilité à froid de la construction dans les conditions normales d’utilisation."
        },
        "addressRequired": "Ce rapport nécessite une adresse confirmée"
      },
      "tryAgainError": "Une erreur est survenue lors de la génération du rapport, veuillez réessayer.",
      "badConfigError": "Une erreur est survenue lors de la génération du rapport, mauvaise configuration du projet, contactez le support",
      "reportGenerationSuccess": "Le rapport a été généré avec succès",
      "validationError": "Une erreur s'est produite lors de la validation du rapport, veuillez réessayer.",
      "generationError": "Une erreur s'est produite lors de la génération du rapport, veuillez réessayer.",
      "uploadError": "Une erreur s'est produite lors du téléchargement du rapport, veuillez réessayer.",
      "steppers": {
        "confirmationDialog": {
          "title": "Quitter sans générer",
          "message": "Toute donnée saisie ne sera pas enregistrée. Êtes-vous sûrs de vouloir quitter ?",
          "quite": "Quitter"
        }
      }
    },
    "canvas_viewer": {
      "code": "Code de rubrique",
      "label": "Nom"
    },
    "project": {
      "avis": "Avis",
      "document": "Documents",
      "reports": "Livrables",
      "details": "Fiche d'identité",
      "ged": "GED",
      "webmail": "Accéder à webmail",
      "download": "Télécharger",
      "name": "Name",
      "tags": "Tags",
      "type": "Type",
      "phase": "Phase",
      "batch": "Lot",
      "creator": "Creator",
      "updated_at": "Updated at",
      "state": "State",
      "view": "View",
      "size": "Size",
      "file": "File",
      "open": "Ouvrir",
      "type_to_search": "Type to search",
      "move_to": "Move to",
      "unselect_all": "Unselect all",
      "create_folder": "Create a folder",
      "delete": "Delete",
      "cancel": "Cancel",
      "validate": "Validate",
      "folder_name": "Folder's name",
      "file_name": "File's name",
      "project_document": "Documents de l'affaire",
      "error_conversion": "Error in conversion",
      "rename": "Rename",
      "rename_folder": "Rename folder",
      "rename_file": "Rename file",
      "advice": "Advice",
      "missing": "missing",
      "save": "Enregistrer",
      "save_text": "Enregistrer les modifications",
      "upload": "Téléversement",
      "upload_text": "Téléverser votre premier fichier",
      "configure": "Configurer l'affaire",
      "role": "Rôle",
      "configuration": "Paramétrage",
      "dashboard": "Tableau de bord",
      "case_number": "Numéro de l'affaire",
      "address": "Situation de l'affaire",
      "email_address": "Email",
      "missions": "Missions confiées",
      "otherMissions": "Autres missions",
      "planification": "Planification",
      "topic_history": "Suivi des avis S et D",
      "risks": "Risques",
      "risk_analysis": "Analyse de risque",
      "plan_of_action": "Plan d'actions en cours",
      "wait_for_bimdata_api": "En attente d'authentification API Bimdata",
      "error_for_bimdata_api": "API Bimdata en erreur, veuillez recharger la page",
      "observations": "Observations",
      "relation": {
        "company": "Entreprise",
        "legal_form": "Forme juridique",
        "client_references": "Références clients",
        "client": "Client",
        "decision_center": "Centre de décision",
        "address": "Adresse",
        "client_contact": "Contact client",
        "production_unit": "Unité de production",
        "contracting_agency": "Agence Socotec Titulaire",
        "project_manager": "Pilote Socotec de l'affaire",
        "subcontracting_agency": "Agence Socotec Sous-Traitante",
        "post_code": "Code postal",
        "city": "Ville",
        "label": "Libellé",
        "code": "Code",
        "phone": "Téléphone",
        "mail": "Mail",
        "name": "Nom",
        "first_name": "Prénom",
        "job": "Fonction"
      },
      "affaire": {
        "details": "Désignation de l'affaire",
        "case_number": "Numéro de l'affaire",
        "case_label": "Nom de l'opération (Atlas)",
        "project_name": "Nom du projet",
        "email": "Email",
        "characteristics": "Caractéristiques de l'affaire",
        "work_description": "Description de l'ouvrage",
        "generate_work_description": "Générer la description de l'ouvrage",
        "recover_pc_at_information": "Récupérer les informations",
        "initial_amount": "Montant initial des travaux (*)",
        "final_amount": "Montant final des travaux",
        "revised_works_amount": "Montant des travaux actualisé",
        "revised_works_amount_tooltip": "À usage interne, ce montant actualisé n'est pas pour le moment repris dans les rapports.",
        "estimated_amount": "Montant prévisionnel des travaux",
        "RICT_publication_date": "Date de publication RICT",
        "estimated_duration": "Durée prévisionnelle des travaux (*)",
        "ope_start_date": "Démarrage prévisionnel des travaux (*)",
        "location": "Situation du projet",
        "address": "Adresse",
        "post_code": "Code postal",
        "city": "Ville",
        "building_permit": "Permis de construire & Autorisation de travaux",
        "building_ministerial_authorization": "N° autorisation ministérielle",
        "chrono_number": "Numéro de chronorapsotec",
        "invoice_date_start": "Date de facturation Démarrage travaux",
        "dce_date": "Date DCE",
        "other": "Autres",
        "safety_register_review": "Avis sur le registre de sécurité",
        "safety_register_constitution_status": "Constitution du registre",
        "safety_register_revision_date": "Dernière révision du registre",
        "O_case_status": "Statut de l'affaire",
        "O_deadline_type": "Type d'échéance",
        "date_work_deadline": "Date échéance travaux",
        "ceaRef": "Référence CEA",
        "show_fields_characteristics": "Afficher les champs annotés (*) dans le livrable pdf",
        "PERMIT_number": "Numéro du PC",
        "PERMIT_acquisition_date": "Date d'obtention",
        "PERMIT_request_date": "Date du dépôt demande ",
        "PERMIT_possible_amendments_date": "Date de modifications éventuels",
        "AUTHORIZATION_number": "N° d'autorisation de travaux",
        "AUTHORIZATION_acquisition_date": "Date d'obtention",
        "AUTHORIZATION_request_date": "Date du dépôt demande ",
        "AUTHORIZATION_possible_amendments_date": "Date de modifications éventuels",
        "competent_authority_name": "Nom Autorité compétente",
        "expiration_date": "Date d'expiration",
        "cover_photo": "Photo du projet"
      },
      "mission": {
        "case_total_before_tax": "Montant total des honoraires sur l'affaire",
        "case_sale_amount": "Montant total des honoraires sur l'affaire à partir des ligne de ventes",
        "case_invoiced": "Montant déjà facturé sur cette affaire",
        "invoice_date_last_deadline": "Date de facturation dernière échéance travaux",
        "mission_content": "Contenu de la mission",
        "date_review_contract": "Date de la revue de contrat",
        "project_sale_amount": "Montant sur ce canevas",
        "project_sale_invoiced": "Montant déjà facturé sur ce canevas",
        "technical_control": "Contrôle technique (toutes missions)",
        "technical_control_organism": "Organisme Agréé",
        "other_missions": "Autres missions H / J...",
        "misson_informations": "Information sur la mission",
        "theme_content": "Contenu du thème",
        "technical_control_themes": "Thèmes AMO du canevas",
        "other_themes": "Autres thèmes",
        "mission_limits": "Limites de mission",
        "additional_comments": "Observations complémentaires"
      },
      "external_profile": "Profil",
      "users": "Intervenants",
      "aiPortal": "Portail IA"
    },
    "projects": {
      "projects": "Mes affaires",
      "case_number": "Numéro de l'affaire",
      "client": "Client",
      "city": "Ville",
      "status": "Statut",
      "manager": "Pilote",
      "atlas_methodo": "Phase Atlas",
      "updated_at": "Date maj",
      "is_bim": "BIM ?",
      "archive": "À archiver",
      "add_project": "Ajouter une affaire",
      "add_project_title": "Création d'une nouvelle affaire",
      "project_id": "Numéro d'affaire",
      "project_name": "Nom du projet",
      "project_manager": "Maître d'ouvrage",
      "client_name": "Nom",
      "address": "Adresse",
      "postal_code": "Code postal",
      "email_address": "Adresse email",
      "add": "Ajouter l'affaire",
      "project_not_found": "Affaire introuvable",
      "project_open_failed": "Impossible d'ouvrir l'affaire",
      "project_access_denied": "Vous n'avez pas accès à cette affaire"
    },
    "canvas": {
      "canvas": "Canevas",
      "canvas_list": "Liste des Canevas"
    },
    "cloud_list": {
      "clouds_list": "Clouds list",
      "rename_cloud": "Rename Cloud",
      "cloud_name": "cloud's name"
    },
    "project_list": {
      "new_project": "New Project",
      "submit": "Submit",
      "project_name": "Project's name",
      "remove": "Remove",
      "rename_project": "Rename Project"
    },
    "dms": {
      "no_creator": "No Creator",
      "move_here": "Move here",
      "move_to": "Move to",
      "choose_destination": "Choose destination"
    },
    "configuration": {
      "title": "Configuration du canevas",
      "success_message": "Affaire mise à jour",
      "error_message": "Erreur lors de la mise à jour d'affaire",
      "project_id": "Numéro d'affaire",
      "isProjectInBIM": "Votre projet est-il en BIM ? *",
      "isProjectRPP": "Votre projet contient-il des RPP ? *",
      "missions": "Missions",
      "no_mission": "Aucune mission disponible",
      "destinations": "Destinations",
      "no_destination": "Aucune destination pour cette selection de missions",
      "types": "Types",
      "no_type": "Aucun type pour cette selection de destinations",
      "submit_error": "Échec de la mise à jour de la configuration",
      "submit_success": "Configuration mise à jour",
      "finish": "Enregistrer",
      "RPP": "RPP: Risques à préventions prioritaire de l'affaire :",
      "successRpp": "RPP mis à jours",
      "errorRpp": "Erreur pendant la mise à jour des RPP",
      "isProjectCEA": "Votre projet est un projet CEA ? (chantier pour l'industrie nucléaire) *",
      "isDefenseSecret": "Votre projet est un projet secret défense ?",
      "risks": "Risques",
      "themes": "Thèmes"
    },
    "notification": {
      "ProjectUpdated": "Projet correctement mis à jour !",
      "Close": "Fermer",
      "ErrorSaving": "Erreur pendant la mise à jour !",
      "noAgency": "Le caneva n'est lié à aucune agence"
    },
    "SEDI": {
      "ExportFailed": "Vos documents n'ont pas pu être exportés !",
      "ImportFailed": "Vos documents n'ont pas pu être importés !",
      "bim360Error": "Une erreur est survenue, veuillez vérifier le statut de votre connecteur",
      "TaskTimeout": "Le traitement est toujours en cours. Il peut prendre plus de temps que prévu.",
      "ImportCompletedWithErrors": "Importation terminée avec quelques erreurs",
      "ImportCompletedSuccessfully": "Importation terminée avec succès",
      "WorkspaceSyncFailed": "La synchronisation de l'espace de travail a échoué !",
      "WorkspaceSyncSuccess": "Espace de travail synchronisé avec succès",
      "WorkspaceSyncPartialError": "Espace de travail synchronisé avec quelques erreurs",
      "WorkspaceSyncTimeout": "La synchronisation a démarré avec succès. Cette opération peut durer jusqu'à 6 minutes."
    },
    "actionPlan": {
      "actionPlan": "Action",
      "addActionPlan": "Ajouter une action",
      "status": "Etat",
      "type": "Type",
      "description": "Description",
      "defaultDocumentDescription": "Document d'exécution à transmettre",
      "defaultWorkDescription": "Visite à effectuer",
      "statuses": {
        "DOING": "En cours",
        "DONE": "Terminée"
      },
      "types": {
        "DOCUMENT": "Documents",
        "WORK": "Travaux"
      }
    },
    "topic": {
      "name": "Titre de l'avis",
      "author": "Par",
      "modifiedByUserAt": "Dernière modification"
    },
    "addDocumentsSuccess": "{count} document{plurial} ajouté{plurial} avec succès",
    "document": {
      "dragDrop": "Cliquer ici ou glisser un fichier",
      "import-success": "Document(s) importé(s) avec succès",
      "deleteDocument": "Supprimer le document",
      "deleteDocuments": "Supprimer les documents",
      "deleteMessage": "Êtes vous sûr de vouloir supprimer ce document ?",
      "deleteMessageMultiple": "Êtes vous sûr de vouloir supprimer ces documents ?",
      "editLinkDocError": "Vous ne pouvez pas modifier un/des document(s) partagé(s) sur d'autres applications / projects. Document(s) concerné(s): {docNames}"
    },
    "common": {
      "others": "Autres"
    },
    "ITM": "ITM",
    "CT": "RapsoTEC",
    "AMO": "HORIZON",
    "filter": "Filtrer",
    "close": "Fermer",
    "back": "Retour",
    "continue": "Continuer",
    "delete": "Supprimer",
    "deleteAll": "Effacer tout",
    "favorites": "Favoris",
    "myCanevas": "Mes canevas",
    "edit": "Editer",
    "preview": "Prévisualiser",
    "download": "Télécharger",
    "documentsWithTopics": "Document(s) relié(s) à un avis",
    "documentsWithoutTopics": "Document(s) sans avis"
  },
  "nl": {
    "notification-management": {
      "code": {
        "canvas": "Canvas",
        "mail": "Mail",
        "report": "Verslag",
        "invitation": "Uitnodiging",
        "topic": "Bericht",
        "report_sent": "Rapport verzonden"
      }
    },
    "global": {
      "yes": "Ja",
      "no": "Geen",
      "back": "Vorige",
      "finish": "Afronden",
      "search": "Zoek op"
    },
    "camera": {
      "errors": {
        "notSupported": "Camera toegang wordt niet ondersteund door deze browser",
        "accessError": "Fout bij toegang tot camera",
        "notActive": "Camera is niet actief",
        "captureError": "Fout bij het maken van de foto",
        "stopError": "Fout bij het stoppen van de camera",
        "fileSelectionError": "Fout bij het selecteren van bestand",
        "fileInputError": "Fout met bestandsinvoer",
        "galleryError": "Fout bij toegang tot galerij"
      }
    },
    "dashboard": {
      "logout": "Afmelden",
      "profile_btn": "Mijn profiel",
      "steering": "Controle",
      "change_password": "Mijn wachtwoord wijzigen"
    },
    "avis": {
      "canvas_viewer": "Canvas",
      "bim_viewer": "BIM",
      "empty_viewer": "Leeg"
    },
    "reports": {
      "author": "Auteur",
      "report_id": "ID verslag",
      "choose_report": "Kies een te leveren verslag",
      "list_of_reports": "Lijst van reeds uitgebrachte verslagen",
      "name": "Naam van het verslag",
      "date": "Datum gemaakt",
      "sheetNumber": "Record nummer",
      "chrono": "Chrono nummer",
      "sentDate": "Datum verzending",
      "meeting": "Vergadering",
      "visit": "Bezoek",
      "status": "Status",
      "sAdvice": "Hangende advies",
      "dAdvice": "Ongunstig advies",
      "projectName": "Naam van het project",
      "statuses": {
        "GENERATING": "In generatie",
        "READY": "Lening",
        "SENT": "Verzonden",
        "ERROR": "Fout"
      },
      "tutoring": "Bijles",
      "choose_recipients": "Mailing lijst",
      "choose_contributors": "Lijst van ondertekenaars",
      "mailCreationTitle": "Mail generatie",
      "createDgdMailLabel": "Een DGD verzoek sturen ?",
      "go_to": "Volgende stap",
      "unnamed_report": "Verslag zonder naam",
      "send": "Sturen",
      "sent": "Gestuurd",
      "synthese": "Samenvatting",
      "recreate": "Creëren",
      "delete": "Verwijder",
      "confirm_delete": "Weet je zeker dat je dit rapport wilt verwijderen?",
      "additional_data": {
        "document_name": "Naam van het document",
        "add_specifics": "Specifieke gegevens voor dit verslag",
        "date_of_visit": "Datum bezoek",
        "entitled": "Titel",
        "l_mission_unfavorable_topic": "Onjuiste mening(en) behouden in de RFCT voor Koude Kracht Opdracht L?",
        "l_mission_s_d_count_positive": "In de RFCT worden ongunstige meningen gehandhaafd over missie L koude kracht",
        "l_mission_s_d_count_is_null": "In de RFCT worden geen ongunstige adviezen gehandhaafd over missie L koude kracht",
        "generate_solidity_question": "Wil je het sterktecertificaat erbij?",
        "no_rfct_exists": "Er is geen RFCT-verslag in de zaak",
        "reference_documents": "Selectie uit de lijst van Socotec-rapporten",
        "parasismic_document": "Referentie van het oorspronkelijke seismische document",
        "visits_and_meetings": "Bezoeken of vergaderingen",
        "add_visit_or_meeting": "Bezoek en vergadering toevoegen",
        "witnesses": "Aanwezigen voor het bezoek",
        "nsi_accessibility": {
          "ladder_way": "Ladderbaan",
          "vehicle_ways": "Machinespoor"
        },
        "final_attestation_answer": {
          "maintainedUnfavorableTopics": "Uitbrengen en handhaven van negatieve adviezen over de koudebestendigheid van de constructie onder normale gebruiksomstandigheden.",
          "liftedUnfavorableTopics": "Afkeurende adviezen over de koudebestendigheid van de constructie onder normale gebruiksomstandigheden afgegeven en opgeheven.",
          "didntEmitUnfavorableTopics": "Heeft geen negatief advies uitgebracht over de koudebestendigheid van de constructie onder normale gebruiksomstandigheden."
        },
        "addressRequired": "Voor dit rapport is een bevestigd adres nodig"
      },
      "tryAgainError": "Er is een fout opgetreden bij het genereren van het rapport. Probeer het opnieuw.",
      "badConfigError": "Er is een fout opgetreden bij het genereren van het rapport, slechte projectconfiguratie, neem contact op met de ondersteuning.",
      "reportGenerationSuccess": "Het rapport is succesvol gegenereerd.",
      "validationError": "Er is een fout opgetreden tijdens de validatie van het rapport, probeer het opnieuw.",
      "generationError": "Er is een fout opgetreden tijdens het genereren van het rapport, probeer het opnieuw.",
      "uploadError": "Er is een fout opgetreden tijdens het uploaden van het rapport, probeer het opnieuw.",
      "steppers": {
        "confirmationDialog": {
          "title": "Afsluiten zonder te genereren",
          "message": "Alle ingevoerde gegevens worden niet opgeslagen. Weet u zeker dat u wilt afsluiten?",
          "quite": "Afsluiten"
        }
      }
    },
    "canvas_viewer": {
      "code": "Item code",
      "label": "Naam"
    },
    "project": {
      "avis": "Advies",
      "document": "Documenten",
      "reports": "Deliverables",
      "details": "Identiteitskaart",
      "ged": "EDM",
      "webmail": "Toegang tot webmail",
      "download": "Download",
      "name": "Naam",
      "tags": "Tags",
      "type": "Type",
      "phase": "Fase",
      "batch": "Partij",
      "creator": "Creator",
      "updated_at": "Bijgewerkt op",
      "state": "Staat",
      "view": "Bekijk",
      "size": "Maat",
      "file": "Bestand",
      "open": "Open",
      "type_to_search": "Type om te zoeken",
      "move_to": "Ga naar",
      "unselect_all": "Alles deselecteren",
      "create_folder": "Een map aanmaken",
      "delete": "Verwijder",
      "cancel": "Annuleren",
      "validate": "Valideer",
      "folder_name": "Naam van de map",
      "file_name": "Naam van het bestand",
      "project_document": "Documenten",
      "error_conversion": "Fout in conversie",
      "rename": "Hernoemen",
      "rename_folder": "Map hernoemen",
      "rename_file": "Bestand hernoemen",
      "advice": "Advies",
      "missing": "ontbrekende",
      "save": "Sla",
      "save_text": "Wijzigingen opslaan",
      "upload": "uploaden",
      "upload_text": "Upload uw eerste bestand",
      "configure": "De koffer opzetten",
      "role": "Rol",
      "configuration": "Opzetten",
      "dashboard": "Dashboard",
      "case_number": "Zaaknummer",
      "address": "Status van de zaak",
      "email_address": "E-mail",
      "missions": "Opdrachten",
      "otherMissions": "Andere opdrachten",
      "planification": "Planning",
      "topic_history": "Follow-up van S&D-mededelingen",
      "risks": "risico",
      "risk_analysis": "Risicoanalyse",
      "plan_of_action": "Actieplan in uitvoering",
      "wait_for_bimdata_api": "In afwachting van authenticatie Bimdata API",
      "error_for_bimdata_api": "Bimdata API in fout, gelieve de pagina opnieuw te laden",
      "observations": "Observaties",
      "relation": {
        "company": "Bedrijf",
        "legal_form": "Rechtspositie",
        "client_references": "Klantreferenties",
        "client": "Klant",
        "decision_center": "Beslissingscentrum",
        "address": "Adres",
        "client_contact": "Klantcontact",
        "production_unit": "Productie-eenheid",
        "contracting_agency": "Socotec agentschap Houder",
        "project_manager": "Socotec piloot van de zaak",
        "subcontracting_agency": "Socotec Onderaannemer Agentschap",
        "post_code": "Postcode",
        "city": "Stad",
        "label": "Opschrift",
        "code": "Code",
        "phone": "Telefoon",
        "mail": "Mail",
        "name": "Naam",
        "first_name": "Voornaam",
        "job": "Positie"
      },
      "affaire": {
        "details": "Aanwijzing van de zaak",
        "case_number": "Zaaknummer",
        "case_label": "Naam van de verrichting (Atlas)",
        "project_name": "Naam van het project",
        "email": "E-mail",
        "characteristics": "Kenmerken van de zaak",
        "work_description": "Beschrijving van de werkzaamheden",
        "generate_work_description": "Werkomschrijving genereren",
        "recover_pc_at_information": "PC/AT-informatie ophalen",
        "initial_amount": "Initiële hoeveelheid werk (*)",
        "final_amount": "Eindbedrag van de werken",
        "revised_works_amount": "Geactualiseerd bedrag van de werken",
        "revised_works_amount_tooltip": "Voor intern gebruik, dit geactualiseerde bedrag wordt voorlopig niet in de rapporten overgenomen.",
        "estimated_amount": "Geraamd bedrag van de werken",
        "RICT_publication_date": "Datum van publicatie STIP",
        "estimated_duration": "Geschatte duur van de werkzaamheden (*)",
        "ope_start_date": "Voorlopig begin van de werkzaamheden (*)",
        "location": "Plaats van het project",
        "address": "Adres",
        "post_code": "Postcode",
        "city": "Stad",
        "building_permit": "Bouwvergunning & vergunning voor werken",
        "building_ministerial_authorization": "Ministeriële Autorisatienummer",
        "BP_number": "BP numner",
        "BP_acquisition_date": "Datum van overname",
        "BP_request_date": "Datum van indiening van het verzoek",
        "BP_possible_amendments_date": "Datum mogelijke wijzigingen",
        "chrono_number": "chronorapsotec nummer",
        "invoice_date_start": "Factuurdatum Begin van de werkzaamheden",
        "dce_date": "Datum DCE",
        "other": "Andere",
        "safety_register_review": "Beoordeling van het veiligheidsregister",
        "safety_register_constitution_status": "Oprichting van het Register",
        "safety_register_revision_date": "Laatste herziening van het register",
        "O_case_status": "Status van het project",
        "O_deadline_type": "Soort termijn",
        "date_work_deadline": "Verloop van het werk",
        "ceaRef": "CEA referentie",
        "show_fields_characteristics": "De geannoteerde velden (*) in het pdf-bestand weergeven",
        "PERMIT_number": "PC nummer",
        "PERMIT_acquisition_date": "Datum verkregen",
        "PERMIT_request_date": "Datum aanvraag ",
        "PERMIT_possible_amendments_date": "Datum van eventuele wijzigingen",
        "AUTHORIZATION_number": "Aantal vergunningen voor werken",
        "AUTHORIZATION_acquisition_date": "Datum verkregen",
        "AUTHORIZATION_request_date": "Datum aanvraag ",
        "AUTHORIZATION_possible_amendments_date": "Datum van eventuele wijzigingen",
        "competent_authority_name": "Naam van de Bevoegde Autoriteit",
        "expiration_date": "Vervaldatum",
        "cover_photo": "Projectfoto"
      },
      "mission": {
        "case_total_before_tax": "Totaal bedrag aan vergoedingen voor de zaak",
        "case_sale_amount": "Totaalbedrag aan vergoedingen voor de zaak uit de verkooplijnen",
        "case_invoiced": "Reeds gefactureerd bedrag voor deze zaak",
        "invoice_date_last_deadline": "Datum van laatste factuur voor werkzaamheden",
        "mission_content": "Inhoud van de opdracht",
        "date_review_contract": "Datum van contractbeoordeling",
        "project_sale_amount": "Bedrag van dit kader",
        "project_sale_invoiced": "Reeds gefactureerd bedrag voor dit kader",
        "technical_control": "Technische controle (alle opdrachten)",
        "technical_control_organism": "Erkende Organisatie",
        "other_missions": "Andere missies H/D...",
        "mission_information": "Informatie over de missie",
        "mission_limits": "Missiegrens",
        "additional_comments": "Aanvullende opmerkingen"
      },
      "external_profile": "Profiel",
      "users": "Interveniënten",
      "aiPortal": "IA Portaal"
    },
    "projects": {
      "projects": "Mijn gevallen",
      "case_number": "Zaaknummer",
      "client": "Klant",
      "city": "Stad",
      "status": "Status",
      "manager": "Pilot",
      "atlas_methodo": "Fase Atlas",
      "updated_at": "Datum maj",
      "is_bim": "BIM?",
      "archive": "Te archiveren",
      "add_project": "Een zaak toevoegen",
      "add_project_title": "Een nieuwe zaak aanmaken",
      "project_id": "Zaaknummer",
      "project_name": "Naam van het project",
      "project_manager": "Projecteigenaar",
      "client_name": "Naam",
      "address": "Adres",
      "postal_code": "Postcode",
      "email_address": "E-mailadres",
      "add": "Koffer toevoegen",
      "project_not_found": "Zaak niet gevonden",
      "project_open_failed": "Kan de zaak niet openen",
      "project_access_denied": "U heeft geen toegang tot deze zaak"
    },
    "canvas": {
      "canvas": "Canvas",
      "canvas_list": "Canvas lijst"
    },
    "cloud_list": {
      "clouds_list": "Lijst met wolken",
      "rename_cloud": "Cloud hernoemen",
      "cloud_name": "naam van de wolk"
    },
    "project_list": {
      "new_project": "Nieuw project",
      "submit": "Dien  in",
      "project_name": "Naam van het project",
      "remove": "Verwijder",
      "rename_project": "Project hernoemen"
    },
    "dms": {
      "no_creator": "Geen Schepper",
      "move_here": "Hierheen.",
      "move_to": "Ga naar",
      "choose_destination": "Kies bestemming"
    },
    "configuration": {
      "title": "Canvas configuratie",
      "success_message": "Bijgewerkt geval",
      "error_message": "Fout bij het bijwerken van de koffer",
      "project_id": "Zaaknummer",
      "isProjectInBIM": "Is uw project in BIM? *",
      "isProjectRPP": "Bevat uw project PPR's? *",
      "missions": "Missies",
      "no_mission": "Geen opdrachten beschikbaar",
      "destinations": "Bestemmingen",
      "no_destination": "Geen bestemming voor deze selectie van missies",
      "types": "Types",
      "no_type": "Geen types voor deze selectie van bestemmingen",
      "submit_error": "Configuratie update mislukt",
      "submit_success": "Configuratie bijgewerkt",
      "finish": "Registreer",
      "RPP": "RPP: Prioritaire risico's van de zaak :",
      "successRpp": "RPP bijgewerkt",
      "errorRpp": "Fout tijdens RPP update",
      "isProjectCEA": "Uw project is een CEA-project (project van de nucleaire industrie) *.",
      "isDefenseSecret": "Uw project is een geheim defensieproject ?"
    },
    "notification": {
      "ProjectUpdated": "Project correct bijgewerkt!",
      "Close": "Sluit",
      "ErrorSaving": "Fout tijdens het updaten!",
      "noAgency": "De caneva is niet verbonden aan een agentschap"
    },
    "SEDI": {
      "ExportFailed": "Uw documenten konden niet worden geëxporteerd!",
      "ImportFailed": "Uw documenten konden niet worden geïmporteerd!",
      "bim360Error": "Er is een fout opgetreden, controleer de status van uw connector",
      "TaskTimeout": "De verwerking is nog steeds aan de gang. Het kan langer duren dan verwacht.",
      "ImportCompletedWithErrors": "Import voltooid met enkele fouten",
      "ImportCompletedSuccessfully": "Import succesvol voltooid",
      "WorkspaceSyncFailed": "Synchronisatie van de werkruimte mislukt!",
      "WorkspaceSyncSuccess": "Werkruimte succesvol gesynchroniseerd",
      "WorkspaceSyncPartialError": "Werkruimte gesynchroniseerd met enkele fouten",
      "WorkspaceSyncTimeout": "Synchronisatie is succesvol gestart. Deze bewerking kan tot 6 minuten duren."
    },
    "actionPlan": {
      "actionPlan": "Actie",
      "addActionPlan": "Actie toevoegen",
      "status": "Staat",
      "type": "Type",
      "description": "Beschrijving",
      "defaultDocumentDescription": "Uit te voeren uitvoeringsdocument",
      "defaultWorkDescription": "Uit te voeren bezoek",
      "statuses": {
        "DOING": "Bezig",
        "DONE": "Gedaan"
      },
      "types": {
        "DOCUMENT": "Documenten",
        "WORK": "Werken"
      }
    },
    "topic": {
      "name": "Titel van de recensie",
      "author": "Door",
      "modifiedByUserAt": "Laatste aanpassing"
    },
    "addDocumentsSuccess": "{count} document{nlplurial} succesvol toegevoegde",
    "document": {
      "dragDrop": "Klik hier of plaats een bestand",
      "import-success": "Document(en) succesvol geïmporteerd",
      "deleteDocument": "het document verwijderen",
      "deleteDocuments": "documenten verwijderen",
      "deleteMessage": "Weet je zeker dat je dit document wilt verwijderen ?",
      "deleteMessageMultiple": "Weet je zeker dat je deze documenten wilt verwijderen ?",
      "editLinkDocError": "U kunt een of meer documenten die zijn gedeeld met andere toepassingen / projecten niet bewerken. Documenten die zijn aangetast: {docNames}"
    },
    "common": {
      "others": "Andere"
    },
    "ITM": "ITM",
    "CT": "RapsoTEC",
    "AMO": "HORIZON",
    "filter": "Filter",
    "close": "Sluit",
    "back": "Terug",
    "continue": "Doorgaan",
    "delete": "Verwijderen",
    "deleteAll": "alles wissen",
    "favorites": "Favourite",
    "myCanevas": "Mijn canvas",
    "edit": "Bewerken",
    "preview": "Voorbeeld",
    "download": "Downloaden",
    "documentsWithTopics": "Document(en) gekoppeld aan een onderwerp",
    "documentsWithoutTopics": "Document(en) zonder onderwerp"
  }
}
